
import api from '@/plugins/api'
import { Vue, Component } from 'vue-property-decorator'
import MenuModal from '@/modules/menu/MenuModal.vue'
import eventBus from '@/plugins/eventBus'
import { envConfiguration } from '@/plugins/globalStaticDatas'

@Component({
  components: { MenuModal },
})
export default class DailyMenu extends Vue {
  dailyMenu: Object = {}
  envConfigurations: any = envConfiguration

  mounted() {
    api()
      .get('daily-menu')
      .then((response) => {
        this.dailyMenu = response.data.data
      })
  }

  openDailyMenuDetails(product: Object) {
    this.$modal.show('menu-details')
    eventBus.$emit('daily-menu:details', product)
  }
}
